import logs from '../Logs/Infrastructure/Logs.reducer';
import requests from '../Requests/Infrastructure/Requests.reducer';
import users from '../Users/Infrastructure/Users.reducer';

const reducer = { logs, requests, users };

export default reducer;
